import { NewsOptions } from 'src/services/api/options/newsOptions';

export const newsKeys = {
  all: ['news'] as const,
  list: () => [...newsKeys.all, 'list'] as const,
  lists: (options?: NewsOptions) => [...newsKeys.list(), options?.Category, options?.Filter, options?.PageIndex, options?.PageSize] as const,
  byId: (id: number | string) => [...newsKeys.all, id] as const,
  categories: ['categories'] as const,
};
